import { useTranslation } from 'react-i18next';
import { faClipboardUser } from '@fortawesome/pro-light-svg-icons/faClipboardUser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Divider, Flex, theme, Typography } from 'antd';
import { useJobStatusTextColor } from 'pos-client/components/scheduleBoard/hooks/useJobStatusTextColor.ts';
import type { OrderJobFulfilmentTechnicianModel } from 'pos-shared/models/orderSchema';
import type { ScheduleBoardJobModel } from 'pos-shared/models/schedulingSchema';

interface OrderJobFulfilmentTechniciansListProps {
  appointmentData: ScheduleBoardJobModel;
  orderJobFulfilmentTechnicians:
    | OrderJobFulfilmentTechnicianModel[]
    | undefined;
  orderJobFulfilmentTechniciansIsLoading: boolean;
  isInConflict?: boolean;
}

export const OrderJobFulfilmentTechniciansList = ({
  appointmentData,
  orderJobFulfilmentTechnicians,
  orderJobFulfilmentTechniciansIsLoading,
  isInConflict,
}: OrderJobFulfilmentTechniciansListProps) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();

  const textColor = useJobStatusTextColor(
    isInConflict ? 'conflict' : appointmentData.state
  );

  if (
    orderJobFulfilmentTechniciansIsLoading ||
    appointmentData.serviceType.toLowerCase() === 'mobile'
  )
    return <></>;

  return (
    <>
      <Flex gap={token.marginXS}>
        <Col style={{ minWidth: 20 }}>
          <FontAwesomeIcon
            icon={faClipboardUser}
            style={{ fontSize: token.fontSizeLG }}
          />
        </Col>
        {orderJobFulfilmentTechnicians?.length ? (
          <ul
            style={{
              gap: token.marginXS,
              padding: 0,
              listStyleType: 'none',
              marginBottom: 0,
            }}
          >
            {orderJobFulfilmentTechnicians?.map((technician) => (
              <li key={technician.userId}>{technician.name}</li>
            ))}
          </ul>
        ) : (
          <Typography.Text
            style={{
              color: textColor,
            }}
          >
            {t('technicians.noTechniciansAssigned')}
          </Typography.Text>
        )}
      </Flex>
      <Divider
        style={{
          margin: '7px 0',
          minWidth: 0,
          width: '100%',
        }}
      />
    </>
  );
};
